import { h } from "@stencil/core";
export const StateMessage = ({ message, state }) => {
    return (h("span", { class: "message" }, state === 'error' && (h("dc-ui-icon", { name: "dc_status_error", color: "red02", size: "tiny" })), message));
};
//# sourceMappingURL=state-message.js.map
